import PropTypes from 'prop-types';
import React from 'react';
import { useSegment } from '../../../components/tracking/trackingProvider.js';
import { useTranslation } from 'react-i18next';
import StaticAddressForm from './staticAddressForm.js';
import GoogleAddress from "../../../components/GoogleAddress";

import Styles from '../../../styles/eventCreation/addressForm.module.css';

export default function AddressForm({formEvent, onChange, autoMode, onAutoModeChange, disabledAutoMode = false, errors={}}) {
    const { t } = useTranslation();
    const { track } = useSegment();

    const [disabled, setDisabled] = React.useState(disabledAutoMode);
    const onDisableAutoMode = React.useCallback(() => {
        onAutoModeChange(false);
        setDisabled(true);
        track('ACTION > ENTER ADDRESS MANUALLY', { 'Page Title': 'CREATE EVENT' })
    }, [onAutoModeChange, setDisabled]);
    
    return (
        <>
            {autoMode ? (
                <GoogleAddress onError={onDisableAutoMode} form={formEvent} onChange={onChange} onAutoModeChange={onAutoModeChange}/>
            ) : (
                <StaticAddressForm address={formEvent.address} onChange={onChange} errors={errors} />
            )}

            {!disabled && (
                <div style={{ marginBottom: '15px' }}>
                    <span className={Styles['switch-address-form']} onClick={() => {
                        if (autoMode) {
                            track('ACTION > ENTER ADDRESS MANUALLY', { 'Page Title': 'CREATE EVENT' })
                        }
                        onAutoModeChange(!autoMode)
                    }
                    }>
                        {t(autoMode ? 'ticket.creationEvent.localization.switchToAddressManualMode' : 'ticket.creationEvent.localization.switchToAddressAutoMode')}
                        </span>
                </div>
            )}
        </>
    )
}

AddressForm.propTypes = {
    onChange: PropTypes.func.isRequired,
    formEvent: PropTypes.object.isRequired,
    autoMode: PropTypes.bool.isRequired,
    disabledAutoMode: PropTypes.bool,
    onAutoModeChange: PropTypes.func.isRequired,
    errors: PropTypes.shape.isRequired
};